// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Register_componentWrapper__QGrUB","contentWrapper":"Register_contentWrapper__-rplV","content":"Register_content__iaQHl","heading":"Register_heading__nSRCZ"};